import React from 'react'
// import './specials.scss'
import AutoMenu from '../../react/AutoMenu'
import {Link} from 'react-router-dom'
export default function () {
  return(
    <div className="catering-page">


      <AutoMenu disableOrder />

      <div className="full-menu-link-wrapper">
        <Link to="/order" className="button">Order Online</Link>
      </div>
    </div>
  )
}
